const getters = {
  isMobile: (state) => state.app.isMobile,
}

export default getters
